import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=2222970b&"
import script from "./FooterLayout.vue?vue&type=script&lang=js&"
export * from "./FooterLayout.vue?vue&type=script&lang=js&"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports